<div class="w-full max-w-screen-xl mx-auto">
	<div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 w-full min-w-0 mt-2">
		<!-- Github issues summary -->
		<div class="sm:col-span-2 md:col-span-4 flex flex-col flex-auto p-6 bg-card shadow rounded-2xl overflow-hidden">
			<div class="flex flex-col sm:flex-row items-start justify-between">
				<div class="text-lg font-medium tracking-tight leading-6 truncate">
					Lista de productos
				</div>

				<button mat-flat-button color="accent" (click)="agregarProducto();" *ngIf="configured">
					<mat-icon svgIcon="heroicons_solid:plus"></mat-icon> Agregar producto
				</button>

				<!-- <button mat-flat-button color="accent" (click)="cargaMasiva();"><mat-icon
						svgIcon="heroicons_solid:plus"></mat-icon> Carga masiva</button> -->
			</div>
			<div class="grid grid-cols-1 lg:grid-cols-1 grid-flow-row gap-6 w-full mt-8 sm:mt-4">
				<div class="row">
					<div class="card p-4" *ngIf="!configured">
						<!-- Icon Section -->
						<div class="d-flex justify-content-center align-items-center rounded-circle bg-primary text-white p-4 mb-4" style="width: 60px; height: 60px; margin: 0 auto;">
							<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="icon-size-10" style="width: 40px; height: 40px;">
								<path stroke-linecap="round" stroke-linejoin="round" d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z"></path>
							</svg>
						</div>
					
						<!-- Title Section -->
						<h5 class="card-title text-center">Emisor Requerido</h5>
					
						<!-- Description Section -->
						<p class="card-text text-secondary text-center">
							Aún no tienes un emisor configurado. Por favor, crea uno para habilitar el acceso a esta sección.
						</p>
					
						<!-- Button Section -->
						<div class="text-center mt-4">
							<a routerLink="/cuenta/nonecompany" class="btn btn-primary">Crear emisor</a>
						</div>
					</div>

					<div *ngIf="!mostrarAddProducto" (cerrarNuevoCliente)="invocarEventoCliente($event)" class="col-12">
						<app-grid-component *ngIf="verGrid" [datos]="objetoGridConfiguration?.Data"
							[columns]="objetoGridConfiguration.Columns"
							[exportExcel]="objetoGridConfiguration.ExportExcel"
							[columnHiding]="objetoGridConfiguration.ColumnHiding"
							[Checkbox]="objetoGridConfiguration.Checkbox" [Editing]="objetoGridConfiguration.Editing"
							[Columnchooser]="objetoGridConfiguration.Columnchooser"
							[searchPanel]="objetoGridConfiguration.SearchPanel"
							[scroll]="objetoGridConfiguration.Scroll" (messageEvent)="receiveMessage($event)"
							(datosevent)="datosMessage($event)" [toolbar]="objetoGridConfiguration.ToolBox"
							(onRowUpdated)="Actualizar($event)" (modificar)='modificar($event.modificar.key)'
							[descargarExcel]="descargarExcel" [nombreReporte]="nombreReporte"
							(eliminar)='EliminarProducto($event.eliminar.key)'>
						</app-grid-component>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>

<div class="flex flex-col flex-auto min-w-0" [ngClass]="{ desactivaPantalla: spinner }" *ngIf="false">
	<!-- <mat-card *ngIf="!mostrarAddProducto">
		<div class="row col-12 col-md-12 col-xs-12">
			<div class="col-12 col-md-4 col-xs-4">
				<button mat-button type="button" #boton2 class="" style="background-color:none;" (click)="addProducto()">
					<span style="color:blue; margin-left: -15px;"><button mat-mini-fab color="primary" (click)="boton2.click()"
							type="button">+</button>
						Agregar Producto</span>
				</button>
			</div>
			<div class="col-12 col-md-4 col-xs-4"></div>
			<div class="col-12 col-md-4 col-xs-4">
				<button mat-button type="button" #botonCargar class="" style="background-color:none;"
					(click)="addCargaMasiva()">
					<span style="color:blue; margin-left: -15px;"><button mat-mini-fab color="primary"
							(click)="botonCargar.click()" type="button">&uarr;</button>
						Carga Masiva de Productos </span>
				</button>
			</div>
		</div>
	</mat-card> -->


	<div class="flex-auto border-t -mt-px pt-4 sm:pt-6">
		<div class="w-full max-w-screen-xl mx-auto">
			<mat-tab-group class="sm:px-2" [animationDuration]="'0'" [selectedIndex]="selectedTab">

				<mat-tab label="Mis Productos">
					<ng-template matTabContent>
						<div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 w-full min-w-0">
							<!-- Github issues summary -->
							<div
								class="sm:col-span-2 md:col-span-4 flex flex-col flex-auto p-6 bg-card shadow rounded-2xl overflow-hidden">
								<div class="flex flex-col sm:flex-row items-start justify-between">
									<div class="text-lg font-medium tracking-tight leading-6 truncate">
										Lista de productos
									</div>

									<button mat-flat-button color="accent" (click)="openDialog();"><mat-icon
											svgIcon="heroicons_solid:plus"></mat-icon> Agregar producto</button>
								</div>
								<div class="grid grid-cols-1 lg:grid-cols-1 grid-flow-row gap-6 w-full mt-8 sm:mt-4">
									<div class="row">

										<div *ngIf="!mostrarAddProducto"
											(cerrarNuevoCliente)="invocarEventoCliente($event)" class="col-12">
											<app-grid-component *ngIf="verGrid" [datos]="objetoGridConfiguration?.Data"
												[columns]="objetoGridConfiguration.Columns"
												[exportExcel]="objetoGridConfiguration.ExportExcel"
												[columnHiding]="objetoGridConfiguration.ColumnHiding"
												[Checkbox]="objetoGridConfiguration.Checkbox"
												[Editing]="objetoGridConfiguration.Editing"
												[Columnchooser]="objetoGridConfiguration.Columnchooser"
												[searchPanel]="objetoGridConfiguration.SearchPanel"
												[scroll]="objetoGridConfiguration.Scroll"
												(messageEvent)="receiveMessage($event)"
												(datosevent)="datosMessage($event)"
												[toolbar]="objetoGridConfiguration.ToolBox"
												(onRowUpdated)="Actualizar($event)"
												(modificar)='modificar($event.modificar.key)'
												(eliminar)='EliminarProducto($event.eliminar.key)'>
											</app-grid-component>
										</div>
									</div>
								</div>
							</div>
						</div>
					</ng-template>
				</mat-tab>

				<mat-tab label="Carga masiva">
					<ng-template matTabContent>
						<div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 w-full min-w-0">
							<!-- Github issues summary -->
							<div
								class="sm:col-span-2 md:col-span-4 flex flex-col flex-auto p-6 bg-card shadow rounded-2xl overflow-hidden">
								<div class="flex flex-col sm:flex-row items-start justify-between">
									<div class="text-lg font-medium tracking-tight leading-6 truncate">Carga masiva
									</div>
								</div>
								<div class="grid grid-cols-1 lg:grid-cols-1 grid-flow-row gap-6 w-full mt-8 sm:mt-4">
									<div class="row">
										<div class="col-12">
											<div>
												<!-- <div class="row justify-content-start  align-items-center"> -->
												<!-- <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12"> -->
												<p>Aquí podrás subir tu <b>catálogo de Productos</b> de forma
													<b>masiva</b>,
													a través de un archivo <b>.xlsx</b>. En <b>Ejemplo de Productos</b>
													se descargará la plantilla base y un documento con los
													detalles para el llenado del archivo.
												</p>
												<!-- </div> -->
												<!-- </div> -->

												<div class="row justify-content-start  align-items-center"
													style="margin-top:10px;">
													<!-- <div class="col-sm-12 col-md-12 col-lg-3 col-xl-3">
														<button mat-button type="button" style="background-color:none;">
															<span style="color:blue;">&darr; Ejemplo de carga masiva</span>
														</button>
													</div> -->
													<div class="col-sm-12 col-md-12 col-lg-2 col-xl-2">
														<button mat-button type="button" style="background-color:none;"
															(click)="DescargarPlantilla()">
															<span style="color:blue;">&darr; Descarga en .xlsx</span>
														</button>
													</div>
													<div
														class="custom-input-file col-sm-12 col-md-12 col-lg-2 col-xl-2">
														<input type="file" style="background-color:none;"
															class="custom-file-input input-file" id="importFile"
															(change)="importExcel($event)">
														<span
															style="color:blue; font-size: 14px;font-weight: 500;">&uarr;
															Subir archivo .xlsx</span>
													</div>
													<!-- <div class="col-sm-12 col-md-12 col-lg-3 col-xl-3">
														<button mat-button type="button" style="background-color:none;">
															<span style="color:blue;">&#8694; Ver estado de los procesos</span>
														</button>
													</div> -->
												</div>

												<div class="col-12 d-flex justify-content-end f12"
													style="margin-top:30px; margin-bottom:20px;">
													<button mat-raised-button color="primary"
														(click)="procesarArchivo()">
														<span>Procesar Archivo</span>
													</button>&nbsp;
													<button mat-raised-button color="warn"
														(click)="EliminaProductoPorOperacion()">
														<span>X Eliminar Todos</span>
													</button>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</ng-template>
				</mat-tab>

			</mat-tab-group>
		</div>
	</div>
</div>
